import type { Dict } from "../core.js";
import type { tingeeConnections as vi } from "../vi/tingeeConnections.js";

export const tingeeConnections: Dict<typeof vi> = {
  title: "Tingee connections — per-VA webhook",
  intro:
    "When a Tingee connection becomes active, bube-banktransfer subscribes a webhook PER VA at Tingee, then scans 10 days of transactions. This is where you see the result and resubscribe on failure. VA numbers are masked.",
  loading: "Loading connections…",
  loadFailed: "Couldn't load Tingee connections.",
  empty: "No Tingee connections yet.",
  showDeleted: "Show deleted connections ({n})",
  allDeleted: "No connections in use — {n} deleted connections are hidden.",
  truncated: "Showing only the {limit} most recent connections.",
  refresh: "Reload",
  "col.company": "Company",
  "col.bank": "Bank · VA",
  "col.stage": "State",
  "col.webhook": "Webhook",
  "col.scan": "Initial scan",
  "stage.awaiting_bank_link": "Awaiting bank link",
  "stage.creating": "Creating VA",
  "stage.awaiting_confirmation": "Awaiting OTP confirmation",
  "stage.awaiting_notify_confirmation": "Awaiting notification confirmation",
  "stage.active": "Active",
  "stage.awaiting_delete_confirmation": "Awaiting delete confirmation",
  "stage.deleted": "Deleted",
  "stage.failed": "Failed",
  "mode.va": "VA",
  "mode.account": "Root account",
  "flow.create_va": "create VA",
  "flow.bank_link": "bank link",
  "env.sandbox": "Sandbox",
  "env.live": "Live",
  unknownCompany: "(company no longer exists)",
  legacyLinkCode: "old « link code » flag — reverts to VA at the next reconcile",
  noVa: "no VA yet",
  "webhook.subscribed": "Subscribed",
  "webhook.failed": "Failed {code}",
  "webhook.skipped.link_code": "Skipped · old « link code » flag, awaiting reconcile",
  "webhook.skipped.no_va": "Skipped · no VA",
  "webhook.never": "Never ran",
  "webhook.meta": "{at} · {n} attempts",
  "scan.done": "Pulled {pulled} · created {created} ({days} days)",
  "scan.failed": "Failed {code}",
  "scan.skipped": "Skipped",
  "scan.never": "Not scanned",
  lastFailure: "Last failure: {code}",
  action: "Resubscribe…",
  notActive: "Only an active connection can be resubscribed.",
  writeOnly: "Requires bube-banktransfer write permission to resubscribe.",
  "confirm.title": "Resubscribe the webhook?",
  "confirm.body":
    "The hub asks bube-banktransfer to call Tingee with the platform key and point balance notifications for VA {va} ({company}) at bube-banktransfer. It calls again even if already subscribed; recorded in the audit log.",
  "confirm.scan": "Rescan 10 days of transactions (idempotent — no duplicates)",
  "confirm.submit": "Resubscribe",
  "confirm.sending": "Sending…",
  failed: "Couldn't resubscribe.",
  "result.subscribed": "Tingee accepted the subscription.",
  "result.failed": "Tingee refused: {code}. The result is saved on the row.",
  "result.skipped": "bube-banktransfer skipped the webhook step ({reason}).",
};
